import React from 'react';

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
}

const GradientText: React.FC<GradientTextProps> = ({ children, className = '' }) => {
  return (
    <span className={`
      bg-gradient-to-r from-sun to-moon
      dark:from-ember dark:to-moon
      bg-clip-text text-transparent
      ${className}
    `}>
      {children}
    </span>
  );
};

export default GradientText;